import { isFunction } from 'lodash-es';
import { useCallback, useRef, useState } from 'react';

type StateOrFn<T extends unknown> = T | ((prevState: T) => T);

const useRefState = <T extends unknown = unknown>(initState: T) => {
  const [innerState, setInnerState] = useState(initState);
  const stateRef = useRef(innerState);
  stateRef.current = innerState;

  const getState = useCallback(() => stateRef.current, []);
  const setState = useCallback((stateOrFn: StateOrFn<T>) => {
    const newState = isFunction(stateOrFn) ? stateOrFn(stateRef.current) : stateOrFn;
    stateRef.current = newState;
    setInnerState(newState);
  }, []);

  const result: [typeof innerState, typeof setState, typeof getState, typeof stateRef] = [
    innerState,
    setState,
    getState,
    stateRef,
  ];
  return result;
};

export default useRefState;
